import matchEntities, { NETHERLANDS } from '../shared/entityHelpers';

// eslint-disable-next-line import/prefer-default-export
export function getRouterLinks(i18n) {
  if (matchEntities(['NETHERLANDS'])) {
    return [
      {
        ref: NETHERLANDS.externalFormCTALink,
        text: 'navigation.google_form_cta',
        highlight: true,
      },
      {
        ref: `/${i18n.locale}/experience`,
        text: 'navigation.experience',
      },
      {
        ref: 'https://qwello.eu/news/',
        text: 'navigation.news',
        isExternal: true,
      },
      {
        ref: `/${i18n.locale}/contact`,
        text: 'navigation.contact',
      },
      {
        ref: `https://qwello.eu/en/map`,
        text: 'navigation.map',
        isExternal: true,
      },
    ];
  }
  return [
    {
      ref: `/${i18n.locale}/contact`,
      text: 'navigation.contact',
      highlight: true,
    },
    {
      ref: `/${i18n.locale}/register`,
      text: 'navigation.register',
    },
    {
      ref: `/${i18n.locale}/experience`,
      text: 'navigation.experience',
    },
    {
      ref: 'https://qwello.eu/news/',
      text: 'navigation.news',
      isExternal: true,
    },
    {
      ref: `/${i18n.locale}/careers`,
      text: 'navigation.careers',
    },
    {
      ref: `https://qwello.eu/en/map`,
      text: 'navigation.map',
      isExternal: true,
    },
    {
      ref: `/${i18n.locale}/faq`,
      text: 'navigation.faqs',
    },
  ];
}
